// © Microsoft Corporation. All rights reserved.

import React, { useCallback, useEffect, useRef, useState } from 'react';
//import { Label, Spinner, SpinnerSize } from '@fluentui/react';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { RemoteVideoStream, VideoStreamRenderer, VideoStreamRendererView } from '@azure/communication-calling';
//import { videoHint, mediaContainer } from './styles/StreamMedia.styles';
import { mediaContainer } from './styles/StreamMedia.styles';
import { utils } from 'Utils/Utils';
import staticMediaSVG from '../assets/staticmedia.svg';
import { Image, ImageFit } from '@fluentui/react';
import { MicIcon, MicOffIcon } from '@fluentui/react-icons-northstar';

export interface RemoteStreamMediaProps {
    label: string;
    stream: RemoteVideoStream | undefined;
    isParticipantStreamSelected: boolean;
    isMutes: boolean;
    isMobile: boolean;
}

interface HTMLMediaElementWithCaputreStream extends HTMLMediaElement {
    captureStream(): MediaStream;
}

//let document: Document;


export default (props: RemoteStreamMediaProps): JSX.Element => {

    const rendererViewRef = useRef<VideoStreamRendererView>();
    console.log("COGBEE :: ROLE");
    /* console.log(props.role);*/
    //let contdvZV = document.getElementById("dvZV") as HTMLInputElement | null;
    //contdvZV = document.getElementById("dvZV") as HTMLInputElement | null;
    //contdvZV ? contdvZV.style.display = "contents" : "";

    let streamId = props.stream ? utils.getStreamId(props.label, props.stream) : `${props.label} - no stream`;

    const [activeStreamBeingRendered, setActiveStreamBeingRendered] = useState(false);
    const [showRenderLoading, setShowRenderLoading] = useState(false);

    const imageProps = {
        src: staticMediaSVG.toString(),
        imageFit: ImageFit.contain,
        styles: {
            root: {
                width: '100%',
                height: '100%',
                display: activeStreamBeingRendered ? 'none' : 'block'
            }
        }
    };



    const loadingStyle = {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };
    let _renderer = false;
    const { label, stream, isParticipantStreamSelected } = props;

    const renderRemoteStream = useCallback(async () => {
        const container = document.getElementById(streamId);
        let container_2 = document.getElementById("vdonew") as HTMLVideoElement | null;
        container_2 = document.getElementById("vdonew") as HTMLVideoElement | null;
        if (container && stream && stream.isAvailable && isParticipantStreamSelected) {
            // if we are already rendering a stream we don't want to start rendering the same stream
            if (activeStreamBeingRendered) {
                return;
            }

            // set the flag that a stream is being rendered
            setActiveStreamBeingRendered(true);
            setShowRenderLoading(true);
            const renderer: VideoStreamRenderer = new VideoStreamRenderer(stream);
            // this can block a really long time if we fail to be subscribed to the call and it has to retry
            rendererViewRef.current = await renderer.createView({ scalingMode: 'Crop' });
            _renderer = true;
            setShowRenderLoading(false);
            if (container && container.childElementCount === 0) {
                container.appendChild(rendererViewRef.current.target);


                try {
                    let el = document.getElementById(streamId) as HTMLElement | null
                    el = document.getElementById(streamId) as HTMLElement | null
                    const streamobj1 = el?.firstChild?.firstChild as HTMLMediaElementWithCaputreStream;
                    const streamobj = streamobj1.captureStream();
                    if (container_2 != null) {
                        container_2.srcObject = streamobj;
                        container_2?.load();
                        container_2?.play();

                    }
                } catch (e) {

                }
            }
        } else {


            if (rendererViewRef.current && _renderer) {
                _renderer = false
                rendererViewRef.current.dispose();
                setActiveStreamBeingRendered(false);
                if (container_2 != null) {
                    container_2.srcObject = null;
                }
            }
        }
    }, [
        stream,
        streamId,
        isParticipantStreamSelected,
        activeStreamBeingRendered,
        setShowRenderLoading,
        setActiveStreamBeingRendered
    ]);

    useEffect(() => {
        if (!stream) {
            return;
        }

        stream.on('isAvailableChanged', renderRemoteStream);

        if (stream.isAvailable) {
            renderRemoteStream();
        }
    }, [stream, isParticipantStreamSelected, renderRemoteStream]);

    const handleClick = (Sid: any) => {

        let container_2 = null;
        container_2 = document.getElementById("vdonew") as HTMLVideoElement | null;

        let containerimg: HTMLElement | null;
        containerimg = document.getElementById("imgnew");
        containerimg = document.getElementById("imgnew");
        streamId = Sid; //event.currentTarget.id;
        try {
            if (container_2 != null && containerimg != null) {
                container_2.style.display = "block";
                containerimg.style.display = "none";

                let el = document.getElementById(streamId) as HTMLElement | null
                el = document.getElementById(streamId) as HTMLElement | null
                const streamobj1 = el?.firstChild?.firstChild as HTMLMediaElementWithCaputreStream;
                const streamobj = streamobj1.captureStream();

                container_2.srcObject = streamobj;
                container_2.load();
                container_2.play();
            }
        } catch (e) {
            //<Image {...imageProps} />
            if (container_2 != null && containerimg != null) {
                container_2.style.display = "none";
                containerimg.style.display = "block";
            }
        }
    };

    let nName = label.split("_")[0];
    const lastIndex = label.lastIndexOf('_');
    
    nName = label.substr(0, lastIndex);

    let nRole = label.substr(lastIndex).replace("_", "");
    nRole = label.substr(lastIndex).replace("_", "");
    nRole = nRole == "Spoc" ? "Interviewer" : nRole;
    return (
        <div className={mediaContainer} onClick={Sid => handleClick(streamId)} >
            <div className="userStreamMicSection" style={{ position: "absolute", right: props.isMobile ? "15px" : 0, zIndex: 1, color: activeStreamBeingRendered ? "#fff" : "#000" }}>
                {!props.isMutes ? <MicIcon size="medium" /> : <MicOffIcon size="medium" />}
            </div>
            <div style={{ display: activeStreamBeingRendered ? 'block' : 'none' }} className={mediaContainer} id={streamId} >
                {showRenderLoading && <Spinner style={loadingStyle} label={`Rendering stream...`} size={SpinnerSize.xSmall} />}
            </div>
            <Image {...imageProps} />
            {/*<Label className={videoHint}>{label}</Label>*/}
            <div className="VedioLabel">
                <div className="vLI">{nName}</div>
                <div className="VedioLabelInt">{nRole}</div>
            </div>
            <div style={{ display: activeStreamBeingRendered ? 'block' : 'none' }} className={mediaContainer} id={streamId + "-new"}>

                {/*<div style={{*/}
                {/*    width: '100%',*/}
                {/*    height: '100%'*/}
                {/*}}>*/}
                {/*    <video*/}
                {/*        style={{*/}
                {/*            width: '100%',*/}
                {/*            height: '100%',*/}
                {/*            objectFit: 'cover'*/}
                {/*        }}*/}

                {/*        id="vdonew"*/}
                {/*    >*/}


                {/*    </video>*/}
                {/*</div>*/}
            </div>
        </div>
    );
};
